<div class="jumbotron">
  <h3 *ngIf="title" class="title mb-0">{{title}}</h3>

  <ng-content></ng-content>
</div>
